import { Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { GlobalTable } from '../../utility/globalTable'
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { getOrganizationDetailDataModel, organizationUserDataModel } from '../../../models/axiosModel';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import deleteDoc from "../../../assets/deleteDoc.svg";
import globalStrenameDocumentyles from "../../../assets/renameDocument.svg";
import agent from '../../../services/api';
import { formatDateAccordingToTimezoneUsingMoment, GENERIC_STATUS, isWaSmbUser } from '../../../utils/constants';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { addMemberPayload } from './addMember';
import moment from 'moment';
import { CHRONOX_USER_ROLE_NAME_KEY, getCurrentOrganizationDetails, getOrganizationNewRole, hasPermissionToUpdateUser, last_updated_at_timestamp_format, LAST_UPDATED_AT_TIMESTAMP_KEY, PRIVATE_USER_EMAIL_KEY, PRIVATE_USER_FIRST_NAME_KEY, PRIVATE_USER_LAST_NAME_KEY, USER_ORGANIZATION_ROLE_NAME_KEY, USER_ORGANIZATION_STATUS_NAME_KEY, userAssignmentRolesToHaveAccessToAddMembers, userDataFromOrganizationDetailResponse, userRolesToHaveAccessToAddMembers } from './organizationConstants';
import GlobalPopUp from '../../utility/globalPopUp';
import UpdateStatusPopup from './updateStatusPopup';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface OrganizationMembersProps {
    setMemberDetails: React.Dispatch<React.SetStateAction<addMemberPayload>>,
    // setFlagAddMember: React.Dispatch<React.SetStateAction<boolean>>,
    setFlagEditMember: React.Dispatch<React.SetStateAction<boolean>>,
    deleteUserAssignmentRole: (user_assignment_role_id: string) => Promise<void>,
}

const OrganizationMembers: React.FC<OrganizationMembersProps> = ({ setMemberDetails, setFlagEditMember, deleteUserAssignmentRole }) => {
    const navigate = useNavigate()
    const { setFlagLoading, userDetail, GetOrganizationDetails, organizationDetails, handleError, userAssignmentRoleData, apiRoutesPermissionAssignment, setFlagAddMemberPopup } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [flagDeleteIntegrationDataPopup, setFlagDeleteIntegrationDataPopup] = useState(false)
    const [selectedUser, setSelectedUser] = useState<null | organizationUserDataModel>(null);
    const [searchParams, setSearchParams] = useSearchParams()
    const organization_id = searchParams.get('organization_id')

    const [flagUpdateStatusPopup, setFlagUpdateStatusPopup] = useState<boolean>(false);

    const breakPoints = {
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const removeMemberFromOrganization = async (emailAddress: string) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))

        // Delete User Assignment Role, If Exist.
        const organizationData = getCurrentOrganizationDetails(organizationDetails, organization_id);
        if (organizationData) {
            const organizationDetails = organizationData?.organization_user_data;
            const userData = userDataFromOrganizationDetailResponse(organizationDetails, emailAddress);

            if (userData) {
                const chronoxUserRole = getOrganizationNewRole(userAssignmentRoleData, userData?.user_assignment_id);
                if (chronoxUserRole) {
                    deleteUserAssignmentRole(chronoxUserRole?.user_assignment_role_id);
                }
            }
        }

        const response = await agent.removeUserFromOrganization.delete(emailAddress)
        if (response.status) {
            showSuccess(response.data.message)
            GetOrganizationDetails()

        } else {
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const organizationValidation = () => {
        if (!organizationDetails) {
            navigate('/')
        }
        else if (organizationDetails && organizationDetails.filter((organization: getOrganizationDetailDataModel) => organization.organization_id == Number(organization_id)).length == 0) {
            navigate('/')
        }
    }

    let headerList = [
        {
            name: "First Name",
            alignment: "left",
            flagIcon: false,
            valueKey: PRIVATE_USER_FIRST_NAME_KEY
            // sx: { width: "20px !important", paddingRight: "0px !important" }
        },
        {
            name: "Last Name",
            alignment: "left",
            flagIcon: false,
            valueKey: PRIVATE_USER_LAST_NAME_KEY
        },
        {
            name: "Email",
            alignment: "left",
            flagIcon: false,
            valueKey: PRIVATE_USER_EMAIL_KEY
        },
        {
            name: "Status",
            alignment: "left",
            flagIcon: false,
            flagHtml: true,
            valueKey: USER_ORGANIZATION_STATUS_NAME_KEY,
            flagEditOnHover: true,
            onClickOfEdit: (rowDetails: organizationUserDataModel) => {
                setFlagUpdateStatusPopup(true);
                setSelectedUser(rowDetails);
            },
            isEditDisable: (rowDetails: organizationUserDataModel) => {
                if(rowDetails?.user_organization_status_name?.toLowerCase() === GENERIC_STATUS['REGISTERED']?.toLowerCase()){
                    return true;
                }
                return !hasPermissionToUpdateUser(rowDetails, userDetail, userAssignmentRoleData, apiRoutesPermissionAssignment)?.flagEditUserAccess
            },
        },
        {
            name: "Role",
            alignment: "left",
            flagIcon: false,
            valueKey: USER_ORGANIZATION_ROLE_NAME_KEY,
        },
        {
            name: "New Role",
            alignment: "left",
            flagIcon: false,
            valueKey: CHRONOX_USER_ROLE_NAME_KEY
        },
        {
            name: "Updated at",
            alignment: "left",
            flagIcon: false,
            valueKey: LAST_UPDATED_AT_TIMESTAMP_KEY
        },

    ]

    const editIconObj = {
        name: "",
        alignment: "right",
        flagIcon: true,
        valueKey: "",
        iconKey: "editIcon"
    }

    const hasUserAssignmentRoles = userDetail?.user_assignment_role_data && userDetail?.user_assignment_role_data?.length > 0;

    const roleName = hasUserAssignmentRoles ? userDetail?.user_assignment_role_data?.[0]?.chronox_user_role_name : userDetail?.user_organization_data?.user_organization_role_name;
    const rolesToHaveAccessToEditMembers = hasUserAssignmentRoles ? userAssignmentRolesToHaveAccessToAddMembers : userRolesToHaveAccessToAddMembers;

    if (roleName && rolesToHaveAccessToEditMembers?.includes(roleName?.toLowerCase())) {
        headerList.push(editIconObj)
    }

    useEffect(() => {
        organizationValidation()
    }, [searchParams])

    const deleteIntegrationDataPopupOpen = (data: organizationUserDataModel) => {
        setFlagDeleteIntegrationDataPopup(true)
        setSelectedUser(data)
    }

    const onClickOfEditUser = (data: organizationUserDataModel) => {
        setMemberDetails((prev) => ({
            ...prev,
            private_user_email: data?.private_user_email,
            private_user_first_name: data?.private_user_first_name,
            private_user_last_name: data?.private_user_last_name,
            organization_role_id: data?.user_organization_role_id,
            private_user_id: data?.private_user_id,
            chronox_user_role_id: getOrganizationNewRole(userAssignmentRoleData, data?.user_assignment_id)?.chronox_user_role_id ?? null
        }));
        setFlagEditMember(true);
        setFlagAddMemberPopup(true);
    }

    const menuItems = [
        {
            label: 'Edit',
            icon: <img src={globalStrenameDocumentyles} alt="edit" width={"16"} height={"16"} />,
            action: (e: organizationUserDataModel) => onClickOfEditUser(e),
            disabled: (rowDetails: organizationUserDataModel) => !hasPermissionToUpdateUser(rowDetails, userDetail, userAssignmentRoleData, apiRoutesPermissionAssignment).flagEditUserAccess
        },
        {
            label: 'Delete',
            icon: <img src={deleteDoc} alt="delete" width={"16"} height={"16"} />,
            action: (e: organizationUserDataModel) => deleteIntegrationDataPopupOpen(e),
            disabled: (rowDetails: organizationUserDataModel) => !hasPermissionToUpdateUser(rowDetails, userDetail, userAssignmentRoleData, apiRoutesPermissionAssignment).flagDeleteUserAccess
        },
    ];

    const getOrganizationUserData = () => {
        if (organizationDetails) {
            const userData: organizationUserDataModel[] = getCurrentOrganizationDetails(organizationDetails, organization_id)?.organization_user_data?.map((user: organizationUserDataModel) => {
                return {
                    ...user,
                    last_updated_at_timestamp: formatDateAccordingToTimezoneUsingMoment(user?.last_updated_at_timestamp, userDetail?.timezone_hour),
                    chronox_user_role_name: getOrganizationNewRole(userAssignmentRoleData, user?.user_assignment_id)?.chronox_user_role_name ?? "-",
                    chronox_user_role_id: getOrganizationNewRole(userAssignmentRoleData, user?.user_assignment_id)?.chronox_user_role_id ?? "-",
                }
            })?.sort((a: organizationUserDataModel, b: organizationUserDataModel) => {
                const timeA = moment(a.last_updated_at_timestamp).format(last_updated_at_timestamp_format);
                const timeB = moment(b.last_updated_at_timestamp).format(last_updated_at_timestamp_format);
                return timeB.localeCompare(timeA)
            });

            const filterNonSMBUsers = userData?.filter((user: organizationUserDataModel) => !isWaSmbUser(user?.private_user_email));

            return filterNonSMBUsers;
        }
        return [];
    }

    const onCloseOfUpdateStatusPopup = () => {
        setFlagUpdateStatusPopup(false);
        setSelectedUser(null);
    }

    return (
        <>
            <Grid container direction={"column"} className={styles.integrationTable}>
                <Grid item xs={12} className={`${globalStyles.globalLibraryFontSize} ${globalStyles.globalHeaderFontWeight} ${globalStyles.globalHeadText} ${styles.subHeading}`}>
                    Workspace Members
                </Grid>
                <Grid item xs={12} className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`}>
                    <GlobalTable
                        headerList={headerList}
                        rowData={getOrganizationUserData()}
                        tableHeight={"78vh"}
                        tableContainerHeight={"auto"}
                        tableContainerMinHeight={"auto"}
                        // onCellClick={(e: any, rowDetail: any) => { rowClicked(e, rowDetail) }}
                        onRowClick={(e: any) => { }}
                        deleteRowData={deleteIntegrationDataPopupOpen}
                        flagPagination
                        menuItemsFromParent={menuItems}
                    />
                </Grid>
                {/* {userDetail && userDetail.user_organization_data && userDetail.user_organization_data.user_organization_role_name == "Organization Owner" &&
                    <Grid item sx={{ maxWidth: "150px", marginTop: "15px" }}>
                        <GlobalButton buttonText={"Add member"} onClick={() => { setFlagAddMember(true) }} className="primaryButtonStyle" />
                    </Grid>} */}
            </Grid>

            {flagDeleteIntegrationDataPopup &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to remove ${selectedUser?.private_user_first_name} from this organization`}
                    open={flagDeleteIntegrationDataPopup}
                    onClose={() => { setFlagDeleteIntegrationDataPopup(false) }}
                    onDelete={(e: any) => {
                        if (selectedUser) {
                            removeMemberFromOrganization(selectedUser.private_user_email)
                        }
                        setFlagDeleteIntegrationDataPopup(false)
                    }}
                />
            }

            {flagUpdateStatusPopup && 
                <GlobalPopUp
                    open={flagUpdateStatusPopup}
                    flagShowCloseIcon
                    handleClose={() => onCloseOfUpdateStatusPopup()}
                    onClose={() => onCloseOfUpdateStatusPopup()}
                    paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "600px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "650px"}
                    borderRadius='10px'
                    titlePadding='0px'
                >
                    <UpdateStatusPopup
                        selectedUser={selectedUser}
                        onCloseOfUpdateStatusPopup={onCloseOfUpdateStatusPopup}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default OrganizationMembers
